import {
  Component,
  OnInit,
  Input,
  ViewChild
} from '@angular/core';
import {
  PageConfigService
} from '../page-config.service';
import {
  AutorizationService
} from '../api/autorization.service';
import {
  PageConfig
} from "../models/display/pageConfig";

import {
  ActivatedRoute
} from '@angular/router';
import {MatSidenav} from '@angular/material/sidenav';
import { ThemeServiceService } from '../theme-service.service';

@Component({
  selector: 'app-offline-home-page',
  templateUrl: './offline-home-page.component.html',
  styleUrls: ['./offline-home-page.component.scss']
})




export class OfflineHomePageComponent implements OnInit {
  @Input() dataKey;
  private seletedService : string = null;
  @ViewChild('sidenav') sidenav:MatSidenav;
  public isLoad = false;

  pageConfig: PageConfig = null;
  constructor(private route: ActivatedRoute, private pageConfigService: PageConfigService, private autorizationService: AutorizationService,private themeService : ThemeServiceService) {

  }
  
  close() {
    this.sidenav.close();
  }

  ngOnInit() {
    this.themeService.currentService.subscribe(item => {
      this.seletedService = item;

     
   });
    
    this.route
    .data
    .subscribe(v => v);

    this.pageConfig = null;
    this.autorizationService.login(null).subscribe(
      reponse => {
        // console.log("login");

        this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
          reponse => {
            //            this.pageConfig = <PageContent>reponse;
            // console.log("this.pageConfig");
            this.pageConfig = < PageConfig > reponse;
            // console.log(this.pageConfig.servicesList);

            this.isLoad = true;
          },
          error => {
            this.pageConfigService.getConfig(this.pageConfigService.defaultConfig).subscribe(
              reponse => {
                this.pageConfig = < PageConfig > reponse;
              }
            )
          }
        )
      }
    )
  }

}
